import { lazy } from 'react';

/**
 * @file LazyPages
 * @description Componentes lazy para optimización de carga
 * Optimización: Code splitting para reducir bundle inicial
 */

// Páginas principales (carga inmediata)
export const HomePage = lazy(() => import('../../pages/HomePage'));

// Páginas de producto (carga bajo demanda)
export const ProductoSOS = lazy(() => import('../../pages/ProductoSOS'));
export const Packs = lazy(() => import('../../pages/Packs'));

// Flujos críticos (preload en hover)
export const Comprar = lazy(() => import('../../pages/Comprar'));
export const Activar = lazy(() => import('../../pages/Activar'));
export const TutorialActivacion = lazy(() => import('../../pages/TutorialActivacion'));

// Panel y gestión (carga autenticada)
export const Panel = lazy(() => import('../../pages/Panel'));

// Onboarding post-asignación (carga autenticada)
export const OnboardingPage = lazy(() => import('../../pages/OnboardingPage'));

// Páginas de soporte (carga bajo demanda)
export const FAQ = lazy(() => import('../../pages/FAQ'));
export const Soporte = lazy(() => import('../../pages/Soporte'));
export const Contacto = lazy(() => import('../../pages/Contacto'));
export const Privacidad = lazy(() => import('../../pages/Privacidad'));
export const ARCOSolicitudes = lazy(() => import('../../pages/ARCOSolicitudes'));
export const Terminos = lazy(() => import('../../pages/Terminos'));
export const CookiePolicy = lazy(() => import('../../pages/CookiePolicy'));
export const LegalVersions = lazy(() => import('../../pages/LegalVersions'));
export const RetractoForm = lazy(() => import('../../pages/RetractoForm'));
export const GarantiaForm = lazy(() => import('../../pages/GarantiaForm'));
export const ConsultarTicket = lazy(() => import('../../pages/ConsultarTicket'));

// Perfil público (optimización crítica)
export const PerfilPublico = lazy(() => import('../../pages/PerfilPublico'));
export const PublicProfile = lazy(() => import('../../pages/PublicProfile'));

// Fallbacks específicos por tipo de página
export const PageFallback: React.FC = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
      <p className="text-gray-600">Cargando página...</p>
    </div>
  </div>
);

export const ModalFallback: React.FC = () => (
  <div className="flex items-center justify-center p-4">
    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary-600"></div>
  </div>
);

export const ComponentFallback: React.FC = () => (
  <div className="flex items-center justify-center p-2">
    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary-600"></div>
  </div>
);
